package com.chariot.landing.util

import androidx.compose.runtime.*
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.delay
import org.w3c.dom.events.EventListener


@Composable
fun ObserveViewportEntered(
    sectionId: String,
    distanceFromTop: Double,
    onViewportEntered: () -> Unit
){

    var isViewportEntered by remember { mutableStateOf(false) }

    val listener = remember {
        EventListener {
            val top = document.getElementById(sectionId)?.getBoundingClientRect()?.top
            if (top != null && top < distanceFromTop){
                isViewportEntered = true
            }
        }
    }



    LaunchedEffect(isViewportEntered){

        if(isViewportEntered){

            onViewportEntered()
            window.removeEventListener(type = "scroll", callback =  listener)
        }else{

            window.addEventListener(type = "scroll", callback = listener)
        }


    }

}




suspend fun animatedNumbers(
    number: Int,
    delay: Long = 10L,
    onUpdate: (Int) -> Unit
){

    (0..number).forEach {

        delay(delay)

        onUpdate(it)

    }


}

